// tslint:disable
import * as $ from 'jquery';
import * as React from 'react';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';
import { clone } from 'lodash';

export interface InputFieldPropInterface {
    className?: string;
    title?: string;
    visibleTitle?: boolean;
    inputSize?: string;
    placeholder?: string;
    property?: string;
    validators?: Validator[];
    field: Field;
    type?: string;
    defaultValue?: string;
    disabled?: boolean;
    onChange?: (value: any) => void;
    autoComplete?: boolean;
    helpText?: string
}

export class InputField extends BaseField<InputFieldPropInterface> {
    public field: Field = this.props.field;
    private readonly defaultValue = clone(this.props.defaultValue);

    public state: any = {
        error: null,
        disabled: this.field.disabled,
        autoComplete: false
    };

    componentDidMount() {

        this.field.registerField();

        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        if (typeof this.props.autoComplete === 'boolean') {
            this.setState({autoCapitalize: this.props.autoComplete});
        }

        if (this.field.placeholder) {
            this.setState({placeholder: this.field.placeholder})
        }

        this.field.onValueChanges$.subscribe((value: any) => {
            this.setViewValue(value);
            this.field.onValidate$.next();

            if (this.props.onChange) {
                this.props.onChange(value);
            }
        });

        if (this.field.value && this.field.registered) {
            this.setViewValue(this.field.value);
        }

        if (typeof this.props.disabled !== 'undefined') {
            this.field.disabled = this.props.disabled;
            this.setState({disabled: this.field.disabled});
        }

        this.field.onDisableChanges$.subscribe((value: boolean) => {
            this.setState({disabled: value});
            this.field.disabled = value;
        });

        if (this.defaultValue) {
            this.field.setValue(this.defaultValue, false, false);
            this.field.onValueChanges$.next(this.defaultValue);
        }
    }

    setViewValue(value: any) {
        $(`#${this.uid + '_input'}`).val(value);
    }

    render() {
        return (
            <div className={this.props.className} id={this.uid}>
                <div className="form-group">
                    {this.props.visibleTitle !== false && <label htmlFor={this.uid + '_input'}>{this.props.title || this.field.title}</label>}
                    <div className={this.props.inputSize ? `input-group input-group-${this.props.inputSize}` : 'input-group'}>
                        <input id={this.uid + '_input'}
                               name={this.uid + '_input'}
                               type={this.props.type || 'text'}
                               className="form-control"
                               placeholder={this.state.placeholder}
                               disabled={this.state.disabled}
                               onChange={(event: any) => this.onValueChange(event)}
                               autoComplete={this.state.autoComplete ? 'true' : 'new-password'}
                        />
                        {this.props.helpText &&
                        <small className="form-text text-muted">{this.props.helpText}</small>
                        }
                        <ValidatorComponent field={this.field}/>
                    </div>
                </div>
            </div>
        );
    }

    private onValueChange(event: any) {
        let value: any = event.target.value;

        if (this.props.type === 'number') {
            value = parseFloat(value);
        }

        this.field.setValue(value);
        this.field.onValidate$.next();
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/input.field.tsx